import type { ValidationObject } from '../../../types/Validation';

export enum InitiatorType {
    Field = 'field',
    Wysiwyg = 'wysiwyg',
    Global = 'global',
    Object = 'Object',
    FieldsFetched = 'fieldsFetched'
}

export enum ValidationState {
    Idle = 'idle',
    Pending = 'pending',
    Resolved = 'resolved',
    Rejected = 'rejected'
}

export type InvalidLinkedPaths = string[];

export interface State {
    data: Record<string, ValidationObject>;
    initiator: {
        type: InitiatorType;
        srcObjectId: string;
    } | null;
    linkedPaths: InvalidLinkedPaths;
    state: ValidationState;
}
